import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderReturn } from '../_interfaces/order-return';

export interface OrderReturnItemInput {
  orderItemId?: number | null;
  productVariantId: number;
  quantity: number;
  condition?: string;
  notes?: string;
}

export interface OrderReturnInput {
  orderId: number;
  reason?: string;
  items: OrderReturnItemInput[];
}

export interface OrderReturnQueryParams {
  pageIndex: number;
  pageSize: number;
  orderId?: number;
  status?: string;
  keyword?: string;
}

export interface OrderReturnStatusCounts {
  total: number;
  requested: number;
  received: number;
  completed: number;
  rejected: number;
}

export interface OrderReturnQueryResult {
  items: OrderReturn[];
  count: number;
  statusCounts: OrderReturnStatusCounts;
}

@Injectable({
  providedIn: 'root',
})
export class OrderReturnsService {
  constructor(private http: HttpClient) {}

  getOrderReturns(params: OrderReturnQueryParams): Observable<OrderReturnQueryResult> {
    return this.http.post<OrderReturnQueryResult>('/order-returns/list', params);
  }

  getOrderReturnById(id: number): Observable<OrderReturn> {
    return this.http.get<OrderReturn>(`/order-returns/${id}`);
  }

  createOrderReturn(input: OrderReturnInput): Observable<OrderReturn> {
    return this.http.post<OrderReturn>('/order-returns', input);
  }

  updateStatus(id: number, status: string): Observable<OrderReturn> {
    return this.http.put<OrderReturn>(`/order-returns/${id}/status`, { status });
  }

  restockItem(itemId: number, warehouse: string): Observable<any> {
    return this.http.put<any>(`/order-returns/items/${itemId}/restock`, { warehouse });
  }
}
